import { ACCOUNT_TYPES } from '../consts';

export type LoginType = 'admin' | 'advisor' | 'participant';

export const getLoginType = (
  accountsRefLogins?: { accountTypeId: string }[]
): LoginType =>
  accountsRefLogins?.some(a => a.accountTypeId === ACCOUNT_TYPES.ADMIN)
    ? 'admin'
    : accountsRefLogins?.some(a => a.accountTypeId === ACCOUNT_TYPES.ADVISORS)
      ? 'advisor'
      : 'participant';
